import axios from "./axiosInstance";

export const fetchCompaniesDetails = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/rating-setting/get-all?page=${page}&perPage=${perPage}&name=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const storeCompanyDetails = async (formData, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/rating-setting/edit/${id}`, formData);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateAdminGeneralSetting = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/general-setting/set-setting`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getOneTimeShipperSetting = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/general-setting/get-setting-for-one-time-shipper`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateBlogStatus = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/blog/update-status/${data.id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchAllNewsLetters = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/get-newsletters/all?page=${page}&perPage=${perPage}&name=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchAllBlogs = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/blog/get-all-blogs?perPage=${perPage}&page=${page}&name=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const createNewBlog = async (formData) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/blog/create`, formData);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateBlog = async (formData, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/blog/edit/${id}`, formData);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteBlog = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/blog/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchUserMessages = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/contact-us/get-all?perPage=${perPage}&page=${page}&name=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateInvoice = async (data, charge_id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/shipment/charges/update/${charge_id}`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateShipment = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`shipment/manage-invoice/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateAdminShipment = async (data, id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/shipment/manage-invoice/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const confirmOneTimeShipperShipment = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/one-time-shipper/create-shipment/${id}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addCharge = async (data, charge_id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `admin/shipment/charges/add/${charge_id}`,
      data
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteAttachmentFile = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`admin/shipment/charges/delete-media/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getTransferUnits = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `product_unit?perPage=${perPage}&page=${page}&filterValue=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addTransferUnits = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/product-unit/create`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateTransferUnits = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/product-unit/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteTransferUnits = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`admin/product-unit/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getCurrenciesList = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/warehouse/currency?perPage=${perPage}&page=${page}&filterValue=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addCurrency = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/warehouse/currency/store`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateCurrency = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`admin/warehouse/currency/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteCurrency = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`admin/warehouse/currency/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getQuoteLogs = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `admin/one-time-shipper/get-quote-logs?perPage=${perPage}&page=${page}&name=${filter}`
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
